import React, { Component } from "react";
import FlexGrowSpace from "../widgets/FlexGrowSpace";
import BackButton from "./menus/BackButton";
import { decreaseZoom, getGlobalZoom, increaseZoom } from "../js/auth";

class MenuItemHeader extends Component {
  state = {};
  render() {
    return (
      <div className="menuItemHeader-1" >
        <BackButton {...this.props} style={{}} />
        <FlexGrowSpace />
        <div id="zoom" style={{ display: "flex", alignItems: "center", "color": "rgb(131, 123, 108)" }}>
          <div onClick={decreaseZoom} className="zoom icon-zoom-out-outline" />
          <h1 id="zoomlevel2" style={{ fontSize: "20px" }}>{getGlobalZoom() * 100}%</h1>
          <div onClick={increaseZoom} className="zoom icon-zoom-in-outline" />
        </div>
        <FlexGrowSpace />
        <span className="myTitle">{this.props.header}</span>
      </div>
    );
  }
}

export default MenuItemHeader;
